// SortingHeader.jsx

import { Tooltip } from "@mui/material";
import { useSorting } from "../../contexts/SortingContext";
import "./Sorting.css";

import { Dropdowns } from "../Dropdowns/Dropdowns";
import { useEffect, useState } from "react";
import { dropdownConfig } from "../../services/dropdownsConfigService";
import { HTTP_RESPONSE_CODES } from "../../globals/globals";
export const SortingHeader = ({
  children,
  showHeaderOrder = true,
  hideArrows = false,
  onFiltersSelected,
  valuesExtractor = {},
  filtersParameters = {},
}) => {
  const { order, loopKey, isAsc, isDesc, properties, columnFilters } =
    useSorting();

  const [filtersResult, setFiltersResult] = useState({});
  const [filtersApplied, setFiltersApplied] = useState([]);
  const [filtersParams, setFiltersParams] = useState(filtersParameters);

  const getDropdownsConfig = async (column, id_dropdown) => {
    const request = await dropdownConfig(id_dropdown);

    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setFiltersResult((prev) => {
        return { ...prev, [column]: request.data.load };
      });
    }
  };

  const getAllDropdowns = async () => {
    if (columnFilters) {
      const filters = Object.entries(columnFilters);
      await Promise.all(
        filters.map(([column, id]) => {
          getDropdownsConfig(column, id);
        })
      );
    }else{
      return;
    }
  };

  useEffect(() => {
    getAllDropdowns();
  }, []);

  return (
    <div className="sorting-component">
      <div className="columns">
        {children}
        {Object.entries(properties).map(([key, label]) => (
          <div key={key} className="column">
            {(columnFilters ? columnFilters.hasOwnProperty(key) : "") &&
            filtersResult[key] ? (
              <Dropdowns
                parameters={filtersParams[key] ? filtersParams[key] : ""}
                data={filtersResult[key]}
                onApplySelection={(e) => {
                  if (!e || e.length === 0) return;

                  const extractedValues = valuesExtractor[key]
                    ? valuesExtractor[key](e)
                    : e;

                  const newFullSelectedMap = {
                    [key]: e,
                  };

                  setFiltersApplied((prev) => {
                    const updated = [
                      ...prev.filter((f) => f.columnName !== key),
                      {
                        columnName: key,
                        value: extractedValues,
                      },
                    ];

                    onFiltersSelected(updated, newFullSelectedMap);
                    return updated;
                  });
                }}
                handleClear={() => {
                  const updated = filtersApplied.filter(
                    (f) => f.columnName !== key
                  );
                  const newFullSelectedMap = { [key]: [] };
                  setFiltersApplied(updated);
                  onFiltersSelected(updated, newFullSelectedMap);
                }}
              >
                <Tooltip title={`Click To Open ${label} Filter`} arrow>
                  <b
                    style={{
                      textDecoration: "underline",
                      color: "#4EC4EF",
                    }}
                  >
                    {label}
                  </b>
                </Tooltip>
              </Dropdowns>
            ) : (
              <b
                style={{
                  cursor: "default",
                }}
              >
                {label}
              </b>
            )}
            {!hideArrows && (
              <div className="arrows" onClick={() => loopKey(key)}>
                <Tooltip
                  arrow
                  title={
                    isAsc(key) ? "Ascending" : isDesc(key) ? "Descending" : ""
                  }
                >
                  <i
                    onClick={() => loopKey(key)}
                    className={`arrow-button ${
                      isAsc(key)
                        ? "icon-arrowup"
                        : isDesc(key)
                        ? "icon-arrowdown"
                        : "icon-hyphen"
                    } ${isAsc(key) || isDesc(key) ? "active" : ""}`}
                  >
                    {showHeaderOrder && order.includes(key) && (
                      <u>{order.indexOf(key) + 1}</u>
                    )}
                  </i>
                </Tooltip>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
